import { useMutation } from "@tanstack/react-query";
import { useCallback, useContext } from "react";
import invariant from "tiny-invariant";
import { getContext } from "./bootstrap";
export var CommandStatus;
(function (CommandStatus) {
    CommandStatus["IDLE"] = "idle";
    CommandStatus["LOADING"] = "loading";
    CommandStatus["SUCCESS"] = "success";
    CommandStatus["ERROR"] = "error";
})(CommandStatus || (CommandStatus = {}));
export const useCommand = ({ contextId } = {}) => {
    const { messaging: messagingContext, queryClient: queryClientContext } = getContext({ id: contextId });
    const queryClient = useContext(queryClientContext);
    const { commandBus } = useContext(messagingContext);
    invariant(commandBus, "You are trying to use the useCommand hook without wrapping your app with the <MessagingProvider>: there is no commandBus.");
    invariant(queryClient, "You are trying to use the useCommand hook without wrapping your app with the <MessagingProvider>: there is no queryClient.");
    const dispatchCommand = useCallback(async (command) => await commandBus(command), [commandBus]);
    const { reset, mutateAsync, status } = useMutation({ mutationFn: dispatchCommand }, queryClient);
    const dispatchFn = useCallback(async (command) => {
        reset();
        await mutateAsync(command);
    }, [mutateAsync, reset]);
    return [dispatchFn, commandStatusByMutationStatus[status]];
};
// The public CommandStatus enum keeps its original values ("pending" is TanStack's).
const commandStatusByMutationStatus = {
    idle: CommandStatus.IDLE,
    pending: CommandStatus.LOADING,
    success: CommandStatus.SUCCESS,
    error: CommandStatus.ERROR,
};
